/*
 * @Description:
 * @version:
 * @Author: 李云飞
 * @Date: 2023-07-13 18:00:39
 * @LastEditors: qq:23983208
 * @LastEditTime: 2023-07-14 09:27:17
 */
import { defineStore } from 'pinia';

export const useCommonStore = defineStore({
  id: 'common',
  state: () => ({
    userData: null,
    spinLoading: null
  }),
  getters: {
    getUserData(state) {
      return state.userData;
    },
    getSpinLoading(state) {
      return state.spinLoading;
    }
  },
  actions: {
    setUserData(userData) {
      this.userData = userData;
    },
    showLoading() {
      this.spinLoading = true;
    },
    hideLoading() {
      this.spinLoading = false;
    }
  }
});
